var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"confetti-loader-wrapper"},[_c('svg',{attrs:{"viewBox":"0 0 1 1"}}),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"confetti-loader"},[_c('div',{staticClass:"effect-1"}),_vm._v(" "),_c('div',{staticClass:"effect-2"}),_vm._v(" "),_c('div',{staticClass:"effect-3"})])
}]

export { render, staticRenderFns }